import styled from "styled-components";

export const StyledButton = styled.button`
  width: 300px;
  background-color: var(--color-yellow);
  border: 2px solid var(--bg-primary);
  border-radius: 10px;
  font-family: var(--font-raleway);
  font-size: 22px;
  font-weight: 700;
  padding: 15px 0;
  color: var(--bg-primary);

  &:hover {
    filter: brightness(1.2);
  }
`;
